<div class="object-editor">
  <div *ngFor="let kv of data | keyvalue">
    <input
      class="kv-cell"
      type="text"
      [ngModel]="kv.key"
      (keyup.enter)="updateKey(kv.key, $event.target.value)"
      (blur)="updateKey(kv.key, $event.target.value)"
    />
    <span class="kv-cell"> = </span>
    <input
      class="kv-cell"
      type="text"
      [ngModel]="kv.value"
      (keyup.enter)="updateValue(kv.key, $event.target.value)"
      (blur)="updateValue(kv.key, $event.target.value)"
    />
    <button (click)="deleteKey(kv.key)" type="button" class="btn btn-danger btn-sm">
      <fa-icon [icon]="['fal','trash']"></fa-icon>
    </button>
  </div>
  <div>
    <input class="kv-cell" type="text" [(ngModel)]="newKey" (keyup.enter)="addNew()" placeholder="name" (blur)="addNew()" />
    <span class="kv-cell"> = </span>
    <input class="kv-cell" type="text" [(ngModel)]="newVal" (keyup.enter)="addNew()" placeholder="value" (blur)="addNew()" />
  </div>
</div>
